export default "ui-overlay-controller{display:none}\n";